import { StrapiActions, StrapiActionTypes, StrapiState } from "../../types/strapiVPO";

const initialState: StrapiState = {};

export const formAddActions = (state = initialState, action: StrapiActions): StrapiState => {
  switch (action.type) {

    case StrapiActionTypes.ADD_REQUEST_VPO: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.ADD_SUCCESS_VPO: {
      const { modelName, data, creatorId } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: [...(state[modelName]?.data || []), data],
          loading: false,
          error: null,
          lastAddedId: data.id,
          lastDocId: data.documentId,
          lastAddedCreatorId: creatorId || null,
        },
      };
    }

    case StrapiActionTypes.ADD_FAILURE_VPO: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.SET_LAST_ADDED_ID_VPO: {
      const { modelName, id } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          lastAddedId: id,
        },
      };
    }

    case StrapiActionTypes.UPDATE_REQUEST_VPO: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.UPDATE_SUCCESS_VPO: {
      const { modelName, data } = action.payload;
      const existingData = state[modelName]?.data || [];
      const updatedData = existingData.map((item: any) =>
        item.id === data.id ? data : item
      );
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          data: updatedData,
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.UPDATE_FAILURE_VPO: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.DELETE_REQUEST_VPO: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.DELETE_SUCCESS_VPO: {
      const { modelName, documentId } = action.payload;
      const existingData = state[modelName]?.data || [];
      // Фильтруем по documentId, так как это уникальный идентификатор в Strapi 5
      const filteredData = existingData.filter((item: any) => item.documentId !== documentId);
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          data: filteredData,
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.DELETE_FAILURE_VPO: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_REQUEST_VPO: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          actionByContext: {
            ...state[modelName]?.actionByContext,
            data: state[modelName]?.actionByContext?.data || [],
            loading: true,
            error: null,
          },
        },
      };
    }

    case StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_SUCCESS_VPO: {
      const { data } = action.payload;
      return {
        ...state,
        'vpo-actions': {
          ...state['vpo-actions'],
          actionByContext: {
            data,
            loading: false,
            error: null,
          },
        },
      };
    }

    case StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_FAILURE_VPO: {
      const { error } = action.payload;
      return {
        ...state,
        'vpo-actions': {
          ...state['vpo-actions'],
          actionByContext: {
            data: [],
            loading: false,
            error,
          },
        },
      };
    }

    case StrapiActionTypes.FETCH_INCONSISTENCIES_BY_ACTION_REQUEST_VPO: {
      return {
        ...state,
        'vpo-inconsistencies': {
          ...state['vpo-inconsistencies'],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.FETCH_INCONSISTENCIES_BY_ACTION_SUCCESS_VPO: {
      const { data } = action.payload;
      return {
        ...state,
        'vpo-inconsistencies': {
          ...state['vpo-inconsistencies'],
          data,
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.FETCH_INCONSISTENCIES_BY_ACTION_FAILURE_VPO: {
      const { error } = action.payload;
      return {
        ...state,
        'vpo-inconsistencies': {
          ...state['vpo-inconsistencies'],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.CLEAR_INCONSISTENCIES_BY_ACTION_VPO: {
      return {
        ...state,
        'vpo-inconsistencies': {
          data: [],
          loading: false,
          error: null,
        },
      };
    }

    default:
      return state;
  }
};
